import React from "react";
import { ChangeTypeCheckbox } from "./ChangeTypeCheckbox";
import { ChangeToColorMappingType } from "../../../types";

interface ChangeTypeSelectorProps {
    disabled: boolean;
    hidden: boolean;
    selectedChangeTypes: string[];
    handleChangesTypeChanged: (changeType: string, value: boolean) => void;
    changeTypeColoring: ChangeToColorMappingType;
}

export const ChangeTypeSelector = (props: ChangeTypeSelectorProps) => {
    const { hidden, changeTypeColoring, selectedChangeTypes, handleChangesTypeChanged, disabled } = props;
    if (hidden) {
        return null;
    }

    const changeTypes = [
        { name: "I", display: "new", color: changeTypeColoring && changeTypeColoring.I },
        { name: "W", display: "removed", color: changeTypeColoring && changeTypeColoring.W },
        { name: "U", display: "modified", color: changeTypeColoring && changeTypeColoring.U },
        {
            name: "O",
            display: "originals",
            color: changeTypeColoring && changeTypeColoring.O,
        },
        { name: "N", display: "unchanged" },
    ];

    const checkboxes = changeTypes.map((changeType) => (
        <ChangeTypeCheckbox
            key={changeType.name}
            name={changeType.name}
            displayName={changeType.display}
            changeTypeValue={selectedChangeTypes && selectedChangeTypes.includes(changeType.name)}
            changeTypeChangedFunction={handleChangesTypeChanged}
            disabled={disabled}
            layerColor={changeType.color}
        />
    ));

    return <div className={"changesVisualizationPanelBodyCheckboxes"}>{checkboxes}</div>;
};
